export const messages = {
  invitation: {
    title: 'Share Free Access',
    description: 'Share an invitation with your friend for free access!',
    accessInfo: 'You can get access by paying 100⭐',
    button: {
      default: 'Get Access 100⭐',
      processing: 'Processing...',
    },
    shareButtonText: 'Share Invitation',
    generatingButtonText: 'Generating...',
    shareMessage: '🎬 Hey! I\'ve got a special invitation for you to try AI video editing app! Create engaging videos with stylish captions and make your content stand out. Join me and get bonuses! 🎯',
  },
  common: {
    loading: 'Loading...',
    retry: 'Retry',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
  },
  welcome: {
    title: 'Welcome! 🎉',
    invitationAccepted: 'You have successfully accepted the invitation. Welcome onboard!',
  },
  navigation: {
    home: 'Create',
    projects: 'Projects',
    profile: 'Profile',
  },
  errors: {
    generateInvitation: 'Failed to generate invitation',
    loadCreations: 'Failed to load creations. Please try again later.',
    loadCreation: 'Failed to load creation details. Please try again later.',
    auth: 'Authentication failed. Please try again.',
    fileUpload: 'Failed to upload file. Please try again.',
    invalidFileType: 'Please select a video file.',
    deleteCreation: 'Failed to delete creation. Please try again.',
    errorTitle: 'Error',
    unknownError: 'Unknown error',
    authenticationRequired: 'Authentication required'
  },
  home: {
    title: 'Your creations',
    emptyState: 'Let\'s create your first creation!',
    createButton: 'Create',
    loading: 'Loading your creations...',
    processing: 'Processing...',
  },
  create: {
    title: 'What do you want to build?',
    buildButton: 'Build it',
    navigation: {
      next: 'Next',
      back: 'Back',
    },
    types: {
      'c-roll': {
        header: 'C-Roll',
        description: 'Make unique vertical engaging video from your existing vertical content',
      },
      kovrification1: {
        header: 'Kovrification1',
        description: 'Make unique vertical engaging video from your existing vertical content',
      },
      'podcast-series': {
        header: 'Podcast Series',
        description: 'Create a series of short videos from your podcast',
      },
      'podcast-moments': {
        header: 'Best Moments',
        description: 'Find most engaging moments in videos and generate short videos with them',
      },
      'ai-captions': {
        header: 'AI Captions',
        description: 'Add beautiful AI-generated captions to your videos',
      },
    },
    upload: {
      title: 'Upload your video',
      description: 'Select a video file to start the process',
      buttonText: 'Select video file',
      uploading: 'Uploading...',
      progress: '{progress}%',
      selectVideo: 'Select video',
    },
    configuration: {
      videoProcessing: {
        title: 'Video Processing',
        verticalProportion: 'Vertical Video Proportion ({value}%)',
        recommended: 'Recommended: up to 75%',
      },
      captions: {
        title: 'Captions',
        enable: 'Enable Captions',
        fontColor: 'Font Color',
        accentColor: 'Accent Color',
        wordsPerLine: 'Words per Line',
        wordsPerLineRecommended: 'Recommended: 3-5 words',
        verticalPosition: 'Vertical Position',
        verticalPositionDescription: 'Distance from top of the video',
      },
    },
    buttons: {
      continue: 'Continue',
      close: 'Close',
    },
  },
  creationDetails: {
    title: 'Creation Details',
    uploadVideo: {
      title: 'Upload Your Video',
      dropzoneText: 'Click or drag video here',
      uploadProgress: '{progress}%',
    },
    processingFailed: {
      title: 'Processing Failed',
      description: 'Unfortunately, we couldn\'t process your video. Please try again or contact support if the issue persists.',
      retryButton: 'Try Again',
    },
    finalCreation: {
      title: 'Final Creation',
    },
    processing: {
      title: 'Processing Your Creation',
      estimatedTime: {
        bestMoments: 'Estimated processing time: ~10 minutes',
        cRoll: 'Estimated processing time: ~3 minutes',
      },
    },
    configuration: {
      title: 'Configuration',
      videoProcessing: {
        title: 'Video Processing',
        verticalProportion: 'Vertical Video Proportion',
      },
      captions: {
        title: 'Captions',
        enable: 'Enable Captions',
        fontColor: 'Font Color',
        accentColor: 'Accent Color',
        wordsPerLine: 'Words per Line',
        wordsPerLineRecommended: 'Recommended: 3-5 words',
      },
    },
    deletePopup: {
      title: 'Delete Creation',
      message: 'Are you sure you want to delete this creation? This action cannot be undone.',
      deleteButton: 'Delete',
      cancelButton: 'Cancel',
    },
    originalFootageTitle: 'Original Footage',
  },
  activation: {
    welcome: 'Welcome {name}!',
    features: {
      videoTransformation: {
        icon: '🎥',
        title: 'Video Transformation',
        description: 'Transform your content into engaging vertical videos',
      },
      autoCaptions: {
        icon: '💬',
        title: 'Auto Captions',
        description: 'Generate and overlay captions automatically',
      },
      smartEditing: {
        icon: '✨',
        title: 'Smart Editing',
        description: 'AI-powered content enhancement and optimization',
      },
    },
    cta: {
      title: 'Get Full Access',
      description: 'Unlock all features and start creating amazing content',
      button: {
        default: 'Get Access for 100⭐️',
        processing: 'Processing...',
      },
    },
  },
  balanceScreen: {
    title: 'Add Balance',
    subtitle: 'Add ✨ to make more videos',
    rateInfo: '1 ✨ = 1 Telegram Star',
    currentBalance: 'Current balance:',
    getSparkles: 'Get {sparkles} sparkles',
    starsAmount: '{stars} stars',
    popularOption: 'Popular',
    payButton: 'Pay with Telegram',
    processing: 'Processing...',
  },
  profile: {
    balanceLabel: 'Balance: ',
    settingsButton: 'Settings',
    settings: {
      title: 'Settings',
      language: {
        title: 'App Language',
        description: 'Select the language used in the app',
        updated: 'Language updated'
      },
      telegramFileType: {
        title: 'Telegram File Sharing',
        description: 'Choose how files are sent to Telegram by default',
        document: 'Send as Document',
        documentDescription: 'Original quality, no compression',
        video: 'Send as Video',
        videoDescription: 'Optimized for streaming',
        updating: 'Updating...',
        updateSuccess: 'Preference updated successfully',
        updateError: 'Failed to update preference',
        selected: 'Selected'
      }
    }
  },
  paymentRequired: {
    title: 'Processing Payment Required',
    yourBalance: 'Your balance:',
    addMoreButton: 'Add more',
    processingButton: 'Processing...',
    payButton: 'Pay and Start Processing',
    insufficientBalanceButton: 'Insufficient Balance',
    paymentFailedError: 'Failed to process payment. Please try again.',
  },
  creationStatus: {
    DRAFT: 'Draft',
    PENDING: 'Processing',
    WAITING_FOR_PAYMENT: 'Not paid',
    IN_PROGRESS: 'Processing',
    COMPLETED: 'Ready',
    FAILED: 'Failed',
  },
  creationItem: {
    editButton: 'Edit',
    deleteButton: 'Delete',
  },
  homeScreen: {
    proBannerLabel: 'Pro',
    proBannerDescription: 'Pay as you go',
    subtitle: 'Select what you want to create',
    proFeatureTag: 'PRO',
    soonFeatureTag: 'SOON',
  },
  draftCreationHandler: {
    bestMomentsProcessingTime: 'Processing time: approximately 10 minutes',
    processingPriceLabel: 'Processing price:',
    calculatingPrice: 'Calculating...',
    defaultPricingInfo: '12/minute',
    yourBalanceLabel: 'Your balance:',
    needMoreSparkles: 'Need {amount} more sparkles',
    enoughSparkles: 'You have enough sparkles to process',
    processingButton: 'Processing...',
    insufficientBalanceButton: 'Insufficient Balance',
    processVideoButton: 'Process Video',
    processingFailedError: 'Failed to start processing. Please try again.',
  },
  bestMomentsProcessing: {
    processingMessages: [
      "Analyzing podcast content...",
      "Identifying engaging segments...",
      "Finding narrative highlights...",
      "Analyzing audio for key moments...",
      "Segmenting content into best parts...",
      "Detecting emotional peaks in conversation...",
      "Evaluating audience engagement points...",
      "Prioritizing the most impactful moments...",
      "Cutting podcast into best segments...",
      "Applying caption styling to highlights...",
      "Optimizing segments for vertical format...",
      "Enhancing audio quality of best moments...",
      "Synchronizing captions with audio...",
      "Finalizing segment transitions...",
      "Rendering final output...",
      "Teaching AI to recognize punchlines...",
      "Finding the perfect 'aha!' moments...",
      "Filtering out awkward silences...",
      "Identifying when hosts get excited...",
      "Looking for storytelling highlights...",
      "Finding moments that make you think...",
      "Detecting passionate discussions...",
      "Capturing knowledge bombs...",
      "Finding unexpected plot twists...",
    ],
    extendedProcessingMessages: [
      "This podcast has a lot of great moments to process...",
      "Finding the perfect segments takes time...",
      "Giving extra attention to complex conversations...",
      "Your content is so good, it deserves careful processing...",
      "Almost there, just adding some final touches...",
      "Processing the fine details of your best moments...",
      "Our AI is working overtime on your podcast...",
      "Hang tight, we're in the final stretch...",
      "Your content is getting VIP treatment...",
      "Just a bit longer for exceptional quality...",
    ],
    earlyCompletionMessages: [
      "Finished ahead of schedule!",
      "Best moments extracted successfully!",
      "Processing complete earlier than expected!",
      "Your best moments are ready sooner than we thought!",
      "Well that was fast! All done!",
    ],
    finishingUp: "Finishing up...",
    almostThere: "Almost there...",
    almostDone: "Almost done...",
    estimatedTime: "Estimated time: {minutes}m {seconds}s (~ 10 minutes total)",
    stillProcessingHeader: "Still Processing...",
    extractingHeader: "Extracting Best Moments",
    finalizingEarlyCompletion: "Finalizing your best moments...",
    description: "We're analyzing your podcast to find and extract the most engaging moments. This typically takes around 10 minutes.",
  },
  sendToTelegramButton: {
    sentMessageDescription: "_✨ Here's your highlight! ✨_\n\n*{title}*\n\n",
    sentMessageButtonText: 'View all highlights',
    successAlert: 'Video sent to Telegram!',
    errorAlert: 'Failed to send video to Telegram.',
    sendingButtonText: 'Sending...',
    idleButtonText: 'Send to Telegram',
  },
  videoPlayer: {
    downloadButtonTitle: 'Download video',
    downloadButtonText: 'Download',
    defaultFilename: 'video.mp4',
  },
  accessRequest: {
    defaultRequesterName: 'Someone',
    requestMessageToOwner: '{name} would like to request access to your creation.',
    viewCreationButton: 'View Creation',
    successPopupTitle: 'Request Sent',
    successPopupMessage: 'Your access request has been sent to the owner. They will be notified in Telegram.',
    errorPopupMessage: 'Failed to send access request. Please try again later.',
    header: 'Access Restricted',
    description: "You don't have permission to view this creation. The owner has set this content to private.",
    sendingButton: 'Sending Request...',
    requestButton: 'Request Access',
    goHomeButton: 'Go back to home',
    privateCreationTitle: "Private Creation",
    privateCreationDescription: "This creation is private. You need access to view it."
  },
  sharingOptions: {
    makePrivateSuccess: 'Creation is now private and only accessible to you.',
    makePublicSuccess: 'Creation is now public and can be shared with anyone.',
    toggleError: 'Failed to update sharing settings. Please try again.',
    shareDefaultText: 'Check out this creation I made!',
    shareError: 'Failed to share creation. Please try again.',
    popupTitle: 'Sharing Options',
    popupMessagePublic: 'This creation is currently public. Anyone with the link can view it.',
    popupMessagePrivate: 'This creation is currently private and only visible to you.',
    makePrivateButton: 'Make Private',
    makePublicButton: 'Make Public',
    shareViaTelegramButton: 'Share via Telegram',
    mainButtonTitle: 'Sharing Options',
    mainButtonText: 'Share',
    popupTitleEnabled: "Sharing Enabled",
    popupTitleDisabled: "Sharing Disabled",
    popupMessageEnabled: "Your creation is now shared. You can copy the link to share with others.",
    popupMessageDisabled: "Your creation is now private.",
    popupMessageUpdateError: "Failed to update sharing settings. Please try again.",
    sectionHeader: "Sharing",
    shareCreationLabel: "Share this creation",
    allowOthersHint: "Allow others to view this creation",
    srDisable: "Disable sharing",
    srEnable: "Enable sharing",
    shareLinkLabel: "Share link:",
    popupTitleCopied: "Link Copied",
    popupMessageCopied: "Share link copied to clipboard"
  },
  captionsStyleSelector: {
    sectionTitle: 'Caption Style',
    imageAltText: 'Caption style {styleId}',
    customizeLabel: 'Customize',
    fontColorLabel: 'Font Color',
    accentColorLabel: 'Accent Color',
    fontSizeLabel: 'Font Size',
    accentFontSizeLabel: 'Accent Font Size',
    defaultColorVisual: 'Def',
    defaultColorText: 'Default',
  },
  onboarding: {
    slides: {
      welcome: {
        title: 'Welcome to Contentum',
        description: 'Transform your videos into engaging social media content.',
      },
      cRoll: {
        title: 'C-Roll',
        description: 'Create vertical videos with captions and dynamic overlays.',
      },
      podcastSeries: {
        title: 'Podcast Series',
        description: 'Turn podcasts into a series of short, engaging videos.',
      },
      podcastMoments: {
        title: 'Podcast Moments',
        description: 'Extract and highlight the best moments from your podcast.',
      },
      aiCaptions: {
        title: 'AI Captions',
        description: 'Add beautiful captions to your videos automatically.',
      },
      balance: {
        title: 'Your Balance',
        description: 'Free sparkles to create your first videos!',
      },
    },
    balanceSlideTitle: 'Your Starting Balance',
    balanceFreeGiftText: 'Welcome Gift!',
    balanceEqualsText: 'This equals to',
    balanceVideoCountText: '{{count}} video',
    balanceVideoCountText_plural: '{{count}} videos',
    balanceRateText: '50 sparkles per video',
  },
  adminPanel: {
    defaultLoadError: 'Failed to load users.',
    accessDeniedError: 'Access Denied: You do not have permission to view this panel.',
    genericErrorPrefix: 'Error: ',
    accessDeniedHeader: '🚫 Access Denied 🚫',
    panelTitle: '🚀 Admin Power Console 🚀',
    impersonatingLabel: 'Currently Impersonating:',
    resetImpersonationButton: 'Reset to My Account',
    loadingUsers: 'Loading users...',
    errorPrefix: 'Error: ',
    noUsersFound: 'No users found.',
    selectedUserTag: 'Selected',
    prevPageButton: 'Prev',
    pageIndicator: 'Page {currentPage} of {totalPages}',
    nextPageButton: 'Next',
    impersonationDisclaimer: 'Impersonation logs you in as the selected user. Use responsibly.',
  },
  projectsScreen: {
    loadingMore: 'Loading...',
    loadMoreButton: 'Load More',
    searchPlaceholder: 'Search creations',
    searchButton: 'Search',
    clearButton: 'Clear',
  },
  kovrificationCreationConfig: {
    captionsTitle: 'CAPTIONS',
    enableCaptionsLabel: 'Enable Captions',
    captionsDisabledPlaceholder: 'Enable captions to select style and customize options',
    proportionTitle: 'VERTICAL VIDEO PROPORTION',
    templateName: 'Template {percent}%',
    customizeButton: 'Customize',
    proportionSliderLabel: 'Vertical Video Proportion',
  },
  kovrificationConfig: {
    primaryFontColorLabel: 'Primary Font Color',
    textPreview: 'Text Preview',
    accentFontColorLabel: 'Accent Font Color',
    accentPreview: 'Accent Preview',
    videoSizeTitle: 'Video Size',
    verticalProportionLabel: 'Vertical Proportion',
    verticalProportionDescription: 'This shows how much of the video will be visible in the top portion. The rest will be blurred.',
  },
  kovrificationStrategy: {
    defaultFilenamePart: 'c-roll',
    defaultTitle: 'C-Roll Video',
    description: 'Here is your C-Roll video.',
  },
  bestMomentsStrategy: {
    processingCompleteTitle: '{name} Processing Complete',
    defaultProcessingCompleteTitle: 'Best Moments Processing Complete',
    noMomentsExtracted: 'No best moments were extracted from this podcast. Please try a different podcast.',
    defaultResultsTitle: 'Best Moments',
    extractedCountText: "We've extracted {count} best moments from your video.",
    hiddenCountSuffix: ' ({count} hidden)',
    defaultMomentTitle: 'Moment {index}',
    hiddenMomentsButton: 'Hidden Moments ({count})',
    unstarButtonTitle: 'Unstar moment',
    starButtonTitle: 'Star moment',
    unhideButtonTitle: 'Unhide moment',
    hideButtonTitle: 'Hide moment',
    scoringSectionTitle: 'Scoring',
    viralScoreLabel: 'Viral Score',
    hookLabel: 'Hook',
    flowLabel: 'Flow',
    valueLabel: 'Value',
    shareabilityLabel: 'Shareability',
    transcriptSectionTitle: 'Transcript',
    analysisSectionTitle: 'Detailed Analysis',
    qualityMetricsExplained: 'Quality Metrics Explained',
    hookRatingLabel: 'Hook Rating: {rating}',
    flowRatingLabel: 'Flow Rating: {rating}',
    valueRatingLabel: 'Value Rating: {rating}',
    shareabilityRatingLabel: 'Shareability Rating: {rating}',
    marketingPotential: 'Marketing Potential',
    trendAlignmentLabel: 'Trend Alignment',
    audienceEngagementLabel: 'Audience Engagement',
  },
  configurationPanel: {
    titleCroll: "C-roll Settings",
    titleBestMoments: "Best Moments Settings",
    titleDefault: "Configuration",
    captionsHeader: "Captions",
    captionsEnabled: "Enabled",
    captionsDisabled: "Disabled",
    verticalProportionHeader: "Vertical Video Proportion"
  },
  selectCreationType: {
    header: "New Project",
    proOnlyBadge: "Pro only",
    comingSoonBadge: "Coming soon",
    proLabel: "PRO",
    soonLabel: "SOON",
    recentHeader: "Recent",
    proModal: {
      featureIsPro: "{{featureName}} is a Pro feature",
      description: "Upgrade to Pro to unlock this feature and get access to more advanced content creation tools.",
      upgradeButton: "Upgrade to Pro",
      cancelButton: "Cancel"
    }
  },
  errorMessage: {
    title: "Something went wrong",
    backToHome: "Back to Home"
  },
  subscriptionPage: {
    headerTitle: "Subscription Plans",
    subtitle: "Choose the plan that works for you",
    subtitleHint: "Upgrade anytime to unlock more features",
    payAsYouGo: {
      name: "Pay as You Go",
      feature1: "Pay only for videos that you're creating",
      feature2: "Basic features",
      currentPlanBadge: "Current Plan"
    },
    pro: {
      name: "Pro",
      feature1: "Create Podcast Best Moments",
      feature2: "Create Podcast series",
      feature3: "More sparkles ✨"
    },
    enterprise: {
      name: "Enterprise",
      feature1: "Build custom workflow",
      feature2: "Content growing strategy for your business",
      feature3: "Priority support"
    },
    contactSupportButton: "Contact Support"
  },
  configureCreationPage: {
    popupErrorTitle: "Error",
    popupErrorMessage: "Failed to save configuration. Please try again.",
    strategyTitleCroll: "C-roll",
    strategyTitleBestMoments: "Best Moments",
    processingPriceLabel: "Processing price:",
    calculatingPriceStatus: "Calculating...",
    defaultPriceDisplay: "12/minute",
    yourBalanceLabel: "Your balance:",
    needsMoreSparklesText: "Need {amount} more sparkles",
    enoughSparklesText: "You have enough sparkles to process",
    insufficientBalanceButton: "Insufficient Balance"
  },
  creationDetailsView: {
    cRollCreationTitle: "C-roll Creation",
    bestMomentsCreationTitle: "Best Moments Creation",
    createdDateLabel: "Created: {date}",
    resultHeader: "Result",
    statusHeader: "Status"
  },
  uploadVideoPage: {
    scrollHintLearnMore: "Scroll to learn more",
    scrollHintUpload: "Scroll to upload",
    aboutHeader: "About {{creationTypeHeader}}",
    proFeatureDescriptionPodcastSeries: "Create engaging podcast series with professional editing and formatting. Perfect for podcast creators looking to enhance their content.",
    proFeatureDescriptionBestMoments: "Automatically extract and highlight the best moments from your podcasts. Save time and create compelling highlight reels.",
    comingSoonHeader: "{creationTypeHeader} is coming soon",
    comingSoonDescription: "We're working hard to bring you this exciting new feature. Stay tuned for updates!",
    comingSoonNotifyButton: "Get notified when it's ready",
    comingSoonFeatureDescriptionAICaptions: "AI Captions will automatically generate accurate captions for your videos using advanced AI technology. Save time and make your content more accessible.",
    uploadHeader: "Upload your video",
    uploadStatusUploading: "Uploading {progress}%",
    uploadStatusSuccess: "File Uploaded Successfully",
    replaceFileButton: "Replace File",
    dropzonePrompt: "Click or drag video here",
    dropzoneHint: "Select a video file to start the process",
    configureWhileWaitingHeader: "Configure while you wait",
    configureWhileWaitingHint: "You can configure your best moments settings while the file is uploading.",
    autoStartCheckboxLabelPrefix: "Auto-start processing",
    autoStartCheckboxLabelSuffix: "after upload completes",
    startProcessingButton: "Start Processing",
    insufficientBalanceHint: "You don't have enough balance to process this creation"
  },
  processingState: {
    finalizingCreation: "Finalizing your creation..."
  },
  bestMomentsConfig: {
    fontColorsHeader: "Font Colors",
    primaryColorLabel: "Primary Color",
    accentColorLabel: "Accent Color",
    textLayoutHeader: "Text Layout",
    wordsPerLineLabel: "Words Per Line",
    sampleCaptionText: "A sample caption could look like:",
    fontSizesHeader: "Font Sizes",
    primarySizeLabel: "Primary Size",
    accentSizeLabel: "Accent Size"
  }
} as const; 